import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {ArtistService} from '../services';
import {IArtist} from '../interfaces';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ArtistsResolverService implements Resolve<IArtist[]> {

    constructor(private artistService: ArtistService) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IArtist[]> {
        return this.artistService.getArtists({}).pipe(map(data => data.results));
    }
}
